import React from 'react';
import { useStyles } from './SignInHeaderComponent.utils';
import Logo from '../Logo/Logo';

interface SignInHeader {
    welcomeText: string;
}

const SignInHeaderComponent: React.VFC<SignInHeader> = ({ welcomeText }) => {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <div className={classes.logo}>
                <Logo />
            </div>
            <div className={classes.welcome}><span>{welcomeText}</span></div>
        </div>
    );
};

export default SignInHeaderComponent;
